/* Texts that does not come from the CMS should be placed here */
const content = {
  global: {
    error: {
      apiError:
        "Es ist ein interner Fehler aufgetreten. Bitte versuchen Sie es später noch einmal",
    },
    restrictedTooltip: "Nur für angemeldete Nutzer",
  },
  userPanels: {
    overview: {
      openLabel: "öffnen",
      cards: {
        dfbNetLink: {
          icon: "share",
          statusIcon: {
            dfbNetLink: "success",
            noDfbNetLink: "error",
          },
          statusText: {
            dfbNetLink: "Sie haben eine DFBnet-Kennung verknüpft",
            noDfbNetLink: "Sie haben keine DFBnet-Kennung verknüpft",
          },
        },
        subscriptions: {
          icon: "favourite",
          statusText: {
            subscribedNone: "Sie haben keine Kategorien abonniert",
            subscribedAllButOne:
              "Sie können noch eine weitere Kategorie abonnieren",
            subscribedSome:
              "Sie können noch $[unsubscribedCategoriesCount] weitere Kategorien abonnieren",
            subscribedAll: "Sie haben alle Kategorien abonniert",
          },
        },
        tasks: {
          icon: "edit",
          statusText: {
            noOpenTasks: "Sie haben keine offenen Aufgaben im Online-Campus",
            oneOpenTask: "Sie haben noch eine offene Aufgabe im Online-Campus",
            severalOpenTasks: "Sie haben noch $[tasksCount] offene Aufgaben im Online-Campus",
          },
        },
        applications: {
          icon: "folder-open",
          statusText: {
            noDfbNetLink: "Bitte verknüpfen Sie Ihre DFBnet-Kennung",
            oneApplication: "Es liegt aktuell eine Bewerbung vor",
            severalApplications:
              "Es liegen aktuell $[openApplicationsCount] Bewerbungen vor",
            noApplicationsOneEvent: "Ein Kurs könnte für Sie interessant sein",
            noApplicationsSeveralEvents:
              "$[eventsCount] Kurse könnten für Sie interessant sein",
            noApplicationsNoEvents:
              "Aktuell liegen keine relevanten Einträge vor",
          },
        },
      },
    },
    dfbNetLink: {
      connected: {
        headline: "DFBnet ist verknüpft",
        richtext:
          "<p>Ihr MEIN.DFB-Konto ist aktuell mit folgender DFBnet-Kennung verknüpft:</p>",
        button: "Verknüpfung entfernen",
      },
      disconnected: {
        headline: "DFBnet ist nicht verknüpft",
        richtext:
          "<p>Ihr MEIN.DFB-Benutzerkonto ist aktuell nicht mit einer DFBnet-Kennung verknüpft." +
          " Sie können eine Verknüpfung über die Angebotsseiten der einzelnen Trainer-Lizenzstufen vornehmen.</p>",
        button: "Zu den Angeboten",
        dfbnetId: "Sie haben noch keine DFBnet-Verknüpfung vorgenommen.",
      },
      confirm: {
        headline: "DFBnet-MEIN.DFB Verknüpfung aufheben",
        cancelButton: "Nein",
        actionButton: "Ja",
        description:
          "Sind Sie sicher, dass Sie die Verknüpfung Ihres DFBnet Kontos aufheben möchten?" +
          " Um die Verknüpfung wiederherzustellen, starten Sie eine neue Bewerbung im Service „Bewerbungsmanagement“",
      },
      error: {
        unauthorized:
          "Bitte loggen Sie sich ein um Ihre DFBnet-Verknüpfung zu verwalten",
      },
    },
    subscriptions: {
      description:
        "Bitte wählen Sie die Artikel-Kategorien aus, die Sie abonnieren möchten",
      subscribeAllLabel: "Alle Kategorien abonnieren",
      unsubscribeAllLabel: "Alle Kategorien abonniert",
      notification: "Automatische E-Mail-Benachrichtigungen für neue Artikel",
      disclaimer: 'Ich willige darin ein. dass die DFB GmbH &amp; Co. KG mir automatische Benachrichtigungen zu den abonnierten Kategorien zusenden darf.<br/><br/>Der Versand der Benachrichtigungen erfolgt auf freiwilliger Basis ihrer Einwilligung gem. Art. 6 Abs. 1 lit. a DSGVO und kann jederzeit ohne Angabe von Gründen widerrufen werden. Die Rechtmäßigkeit der bis zum Widerruf der Einwilligung erfolgten Verarbeitung wird davon nicht berührt. Details zur Verarbeitung und euren Rechten findet ihr in der <a href="https://www.dfb.de/datenschutzerklaerung/" class="dfb-Textlink" target="_blank">Datenschutzerklärung</a>.',
      error: {
        unauthorized:
          "Bitte loggen Sie sich ein um Ihre Abbonements zu verwalten",
      },
    },
    tasks: {
      taskList: {
        button: "Zum Online-Campus",
        columns: {
          courseName: "Kurs:",
          date: "Bearbeitungszeitraum:",
          status: "Status:",
        },
      },
      noTasks: {
        headline: "Nichts zu tun.",
        richtext:
          "<p>Aktuell existieren keine Aufgaben für Sie im Online-Campus.</p>",
        button: "Zum Online-Campus",
      },
      error: {
        unauthorized:
          "Bitte loggen Sie sich ein um Ihre Aufgaben im Online Campus zu sehen",
      },
    },
    applications: {
      applicationList: {
        copyWithData: "Sie haben aktuell folgende Bewerbungen abgegeben:",
        copyNoData: "Sie haben aktuell keine Bewerbungen abgegeben",
        button: "zur Bewerbung",
        columns: {
          license: "Lizenzstufe:",
          date: "Datum:",
          status: "Bewerbungsstatus:",
        },
      },
      eventList: {
        copyWithData:
          "Sie verfügen über eine gültige $[licenseName]-Lizenz. Folgende Kurse könnten für Sie interessant sein:",
        copyNoData:
          "Für Ihre Lizenzstufe können wir Ihnen keine geeigneten Aus-/Fort- und Weiterbildungsveranstaltungen vorschlagen.",
        button: "mehr Info",
        columns: {
          license: "Lizenzstufe:",
          date: "Zeitraum:",
          status: "Buchungsstand:",
        },
      },
      noDfbNetLink: {
        headline: "Bitte verknüpfen Sie Ihre DFBnet-Kennung.",
        richtext:
          "<p>Sie verfügen aktuell über keine Verknüpfung mit ihrer DFBnet-Kennung. Diese wird benötigt um Ihre Lizenzinformationen abzurufen und Ihnen passende Fortbildungen anzubieten sowie eine Übersicht über laufende Bewerbungen zu geben.</p>" +
          "<p>Sie können eine Verknüpfung über die Angebotsseiten der einzelnen Trainer-Lizenzstufen vornehmen.</p>",
        button: "Zu den Angeboten",
      },
      error: {
        unauthorized:
          "Bitte loggen Sie sich ein um Ihre Trainer-Bewerbungen zu sehen",
      },
    },
  },
  restrictedPage: {
    headlineLogin: "Bitte melden Sie sich an",
    paragraphLogin:
      "Dieser Artikel ist angemeldeten Nutzern vorbehalten. Bitte melden Sie sich mit Ihrem Mein.DFB-Konto an.",
    buttonLogin: "Zur Anmeldung",
    headlineBenefits: "Noch nicht registriert?",
    paragraphBenefits:
      "Sie haben noch kein MEIN.DFB-Konto? Registrieren Sie sich jetzt kostenlos und profitieren Sie von zahlreichen Vorteilen.",
    cancelButton: "Zurück",
    actionButton: "Jetzt registrieren",
  },
  signupCard: {
    headline: "Nur für Sie",
    paragraph:
      "Sie haben noch kein MEIN.DFB-Konto? Registrieren Sie sich jetzt kostenlos und profitieren Sie von zahlreichen Vorteilen.",
    button: "Jetzt registrieren",
  },
  accountBenefits: [
    {
      headline: "Freier Zugriff auf alle Artikel",
      richtext: `<p>Lesen Sie Artikel, die wir exklusiv für unsere angemeldeten Nutzer bereitstellen</p>`,
      icon: "locked",
    },
    {
      headline: "Individuelle Artikelvorschläge",
      richtext: `<p>Auf Basis der von Ihnen gewählten Interessen erhalten Sie ausgewählte Artikelvorschläge – passend zu Ihren Lesegewohnheiten.</p>`,
      icon: "favourite",
    },
    {
      headline: "DFBnet-Verknüpfung",
      richtext: `<p>Eine Verknüpfung mit Ihrer DFBnet-Kennung ermöglicht Ihnen die Online-Bewerbung für DFB Aus-/Fort- und Weiterbildungen sowie die Nutzung des Online-Campus, der Blended-Learning-Plattform des DFB.</p>`,
      icon: "share",
    },
    {
      headline: "Ein Konto für alles",
      richtext: `<p>Mit Ihrem MEIN.DFB-Konto haben Sie Zugriff auf eine Vielzahl von DFB-Portalen: Die <a href="https://www.dfb-akademie.de">DFB-Akademie</a>, <a href="https://www.dfb.de" target="_blank">dfb.de</a> und das <a href="https://tickets.dfb.de/" target="_blank">DFB-Ticketportal</a>.</p>`,
      icon: "where",
    },
  ],
  sweatRate: {
    headline: 'Sweat Rate Calculator',
    weight_before_placeholder: 'Gewicht vor Training (kg)',
    weight_before_error: 'Bitte geben Sie den Wert im korrekten Format ein (z.B. 78,4).',
    weight_after_placeholder: 'Gewicht nach Training (kg)',
    weight_after_error: 'Bitte geben Sie den Wert im korrekten Format ein (z.B. 78,4).',
    calculation_error: 'Bitte prüfen Sie die eingegebenen Werte.',
    hydration_placeholder: 'notwendige Flüssigkeitszufuhr (Liter)',
    hydration_tooltip: '',
    image: {
      src: 'https://assets.dfb.de/uploads/000/237/389/original_original.jpg?1618267930',
      alt: 'Stimmungsbild'
    }
  },
  anchorNavigation: {
    open: 'Abschnitte einblenden',
    close: 'Abschnitte ausblenden',
  }
}
export default content
